// Style Imports
import Styles from './InstructionsPane.module.scss';
import 'highlight.js/styles/github.css';

// Module Imports
import { marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import DOMPurify from 'dompurify';

import { IconButton } from '@mui/material';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { Close } from '@mui/icons-material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

import Tooltip from '@mui/material/Tooltip';

//Customizing marked with language highlight
marked.setOptions({
    "async": false,
    "gfm": true,
})

const InstructionsPane = ({ content, isMuted, handleVoiceClick, toggleInstructions, copyButton, isCopyEnabled }) => {
    if (!content) content = 'No Instructions to display';
    // Convert Markdown to HTML and sanitize it
    const getMarkdownText = () => {
        const rawHTML = marked.parse(
            content?.replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/, '')
        );

        const htmlWithTargetBlank = rawHTML.replace(
            /<a\s+href="(.*?)">/g,
            '<a href="$1" target="_blank" rel="noopener noreferrer">'
        );

        return {
            __html: DOMPurify.sanitize(htmlWithTargetBlank, {
                ADD_ATTR: ['target', 'rel']
            }),
        };
    };

    return (
        <div id="instructionsContainer" style={{ display: 'flex', flexDirection: 'column', width: '45vw', height: '100%' }}>
            <div id="treeHeader" className={Styles.treeHeader}>
                <span style={{ marginLeft: '0.8em' }}>{`Instructions`.toUpperCase()}</span>
                <div id="headerButtons" className={Styles.headerButtons}>
                    {isCopyEnabled && (
                        <Tooltip title="Copy Instructions">
                            <span>{copyButton}</span>
                        </Tooltip>
                    )}

                    <Tooltip title="Toggle Sound">
                        <span>
                            <IconButton size="small" onClick={handleVoiceClick}>
                                {isMuted ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
                            </IconButton>
                        </span>
                    </Tooltip>

                    <Tooltip title="Close Instructions">
                        <span>
                            <IconButton size="small" onClick={toggleInstructions}>
                                <Close fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>

                </div>
            </div>
            <div
                id="instructions"
                className={`${Styles.instructions} ${!isCopyEnabled ? Styles.noCopy : ''}`}
                dangerouslySetInnerHTML={getMarkdownText()}
            />
        </div>
    );
};

export default InstructionsPane;
